/*
 * @Date: 2022-04-21 21:31:56
 * @LastEditors: Xiaowei Zhang
 * @LastEditTime: 2022-10-31 14:25:59
 * @FilePath: /kittens/src/index.tsx
 * @Description: 
 */
// import VConsole from 'vconsole';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <HashRouter>
    <App />
  </HashRouter>
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
